import { createEntityAdapter, EntityState } from '@ngrx/entity';
import {
    Action,
  ActionReducer,
  ActionReducerMap,
  createFeatureSelector,
  createReducer,
  createSelector,
  MetaReducer,
  on,
} from '@ngrx/store';
import { serverAccountInfoModel } from '../models/serverResponse.model';
import { AccountActions } from './account-action-types';

export interface AccountState extends EntityState<serverAccountInfoModel>{
    loadedUserInfo: boolean
}

export const adapter = createEntityAdapter<serverAccountInfoModel>({
    selectId: (account:serverAccountInfoModel) => account.userId
    //sortComparer 
}); 

export const initialUserState = adapter.getInitialState({
    loadedUserInfo: false
});

export const accountReducer = createReducer(
    initialUserState,
    on(AccountActions.UserInformationLoaded, (state,action) => adapter.addOne(action.userInfo, {...state, loadedUserInfo:true})),
    on(AccountActions.updateUserInformation, (state,action) => adapter.updateOne(action.userInfo, {...state, loadedUserInfo:true})),
    on(AccountActions.UserInformationUnreachable, (state,action) => adapter.removeAll({...state, loadedUserInfo:false}))
)

export const {selectAll} = adapter.getSelectors();

export function accreducer(state: any | undefined, action: Action) {
    return accountReducer(state, action);
}